/**
 *  使用マーク削除VO
 *
 * @export DeleteUseMarkModel
 * @class DeleteUseMarkModel
 */
export class DeleteUseMarkModel {
  // 受注コード
  public orderCode = String('');
  // 生協コード
  public coopCode = String('');
  // Ｐコード
  public pCode: Array<any> = new Array<any>();
  // マークコード
  public markCode = String('');
  // 注文商品区分
  public orderGoodsFlg = String('');
  // 受付開始受注コード
  public receiptSOrderCode = String('');
  // 注文コード
  public orderNum6Digits = String('');
  // アイテムコード
  public itemCode = String('');

  // いつでも注文
  public nvalList: Array<any> = new Array<any>();

  /**
   * 注文商品区分（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma: Array<any> = new Array<any>();
}
